import {
  jsxDEV as reactJsxDEV,
  jsx as reactJsx,
  jsxs as reactJsxs,
} from "react-native-css-interop/jsx-dev-runtime";
import { wrap } from "../../wrap";
import { interop } from "./interop";
import html from "../../html";

interop(html);

export const jsxDEV = wrap(reactJsxDEV);
export const jsx = wrap(reactJsx);
export const jsxs = wrap(reactJsxs);

export { Fragment, createElement } from "react";
